import api from './api'

const ENDPOINT = '/admin/users'

const UsersService = {
  async getAll(params = {}) {
    const response = await api.get(ENDPOINT, { params })
    return response.data
  },

  async getById(id) {
    const response = await api.get(`${ENDPOINT}/${id}`)
    return response.data
  },

  async create(data) {
    const response = await api.post(ENDPOINT, data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`${ENDPOINT}/${id}`, data)
    return response.data
  },
}

export default UsersService
